/*
 * Woodlanders collection quick-filter chips.
 * Keeps chip state in sync with the current URL and routes chip clicks
 * through the theme's AJAX facet system (FacetFiltersForm), so chips stay
 * consistent with the sidebar filters and the "Clear all" button. Falls
 * back to normal link navigation when the facet JS is unavailable. Chips
 * are generic: each carries data-param + data-value, so no filter values
 * are hardcoded here.
 */
(function () {
  if (window.__wlChipsInit) return;
  window.__wlChipsInit = true;

  function toggleQs(param, value, active) {
    var params = new URLSearchParams(window.location.search);
    if (active) {
      var keep = params.getAll(param).filter(function (x) { return x !== value; });
      params.delete(param);
      keep.forEach(function (x) { params.append(param, x); });
    } else {
      params.append(param, value);
    }
    return params.toString();
  }

  function sync() {
    var params = new URLSearchParams(window.location.search);
    document.querySelectorAll('[data-wl-chip]').forEach(function (a) {
      var param = a.getAttribute('data-param');
      var value = a.getAttribute('data-value');
      var active = params.getAll(param).indexOf(value) !== -1;
      a.classList.toggle('wl-chip--on', active);
      if (active) { a.setAttribute('aria-pressed', 'true'); } else { a.removeAttribute('aria-pressed'); }
      var qs = toggleQs(param, value, active);
      a.setAttribute('href', window.location.pathname + (qs ? '?' + qs : ''));
    });
  }

  function onClick(e) {
    var a = e.target.closest('[data-wl-chip]');
    if (!a) return;
    // Enhancement only: without the theme facet JS, let the link navigate normally.
    if (typeof FacetFiltersForm === 'undefined' || !FacetFiltersForm.renderPage) return;
    var param = a.getAttribute('data-param');
    var value = a.getAttribute('data-value');
    var active = new URLSearchParams(window.location.search).getAll(param).indexOf(value) !== -1;
    e.preventDefault();
    FacetFiltersForm.renderPage(toggleQs(param, value, active), null);
    setTimeout(sync, 80);
  }

  function init() {
    sync();
    document.addEventListener('click', onClick);
    window.addEventListener('popstate', sync);
    // The theme re-renders #ProductGridContainer on every filter change
    // (sidebar input, chip, or Clear all). Re-sync chips whenever it does.
    var grid = document.getElementById('ProductGridContainer');
    if (grid && window.MutationObserver) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(sync, 60);
      }).observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();
